// extracted by mini-css-extract-plugin
module.exports = {"root":"historyVisual-module--root--23ont"};